import * as React from 'react';
import moment from 'moment';
import * as i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LANGUAGE, MARKET } from '../../constants/storageKeys';
import { defaultLangPerMarket } from '../../constants/flags';
import { useInfoMessages } from '../../hooks/useInfoMessages';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { isRecentlyUpdated } from '../../constants/recentlyUpdated';

function InfoMessages() {
    const market = window.localStorage.getItem(MARKET) ?? 'se';
    const lang = defaultLangPerMarket[market] || localStorage[LANGUAGE] || 'sv-SE';
    const { data: infoMessages = [], isLoading } = useInfoMessages(lang);

    return (
        <Box data-testid="news-panel">
            <Typography variant="h5" fontWeight={600} gutterBottom>
                {i18next.t('headers.news')}
            </Typography>
            <Paper elevation={0} className="homePageTable" sx={{ border: '1px solid', borderColor: 'divider', p: 1.5, position: 'relative', pb: 5 }}>
                {isLoading && <Typography variant="body2" color="text.secondary">{i18next.t('common.loading')}</Typography>}
                {infoMessages.slice(0, 6).map(msg => (
                    <Box key={msg.infoMessageId} sx={{ mb: 1.5 }}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            {moment(msg.showFromDateUTC).format('L')}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography
                                component={Link}
                                to={'/infomessage/' + msg.infoMessageId}
                                sx={{ color: 'secondary.main', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                            >
                                {msg.title}
                            </Typography>
                            {isRecentlyUpdated(msg.updateDateUTC) && (
                              <Chip size="small" label={i18next.t('site.recentlyUpdated')} data-testid="recently-updated" color="success"
                                    sx={{ height: 18, flexShrink: 0, '& .MuiChip-label': { px: 1.0, fontSize: '0.65rem' } }} />
                            )}
                        </Box>
                    </Box>
                ))}
                <Button
                    component={Link}
                    to={'/infomessages'}
                    size="small"
                    color="secondary"
                    variant="contained"
                    endIcon={<ArrowForwardIcon />}
                    sx={{ position: 'absolute', bottom: 8, right: 8, borderRadius: 0 }}
                >
                    {i18next.t('common.readmore')}
                </Button>
            </Paper>
        </Box>
    );
}

export default withTranslation('translations')(InfoMessages);
